import { render, staticRenderFns } from "./maincontainer.vue?vue&type=template&id=63540105&scoped=true&"
import script from "./maincontainer.vue?vue&type=script&lang=js&"
export * from "./maincontainer.vue?vue&type=script&lang=js&"
import style0 from "./maincontainer.vue?vue&type=style&index=0&id=63540105&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63540105",
  null
  
)

export default component.exports